import utility from 'src/utils/utility'
import DashboardV2 from 'src/app/dashboardv2'

export default utility.routeData('dashboardv2', 'DashboardV2', <DashboardV2 />)